import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Grid,
    GridColumn,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    DataForm,
} from '../../components/Form';


import {
    Title,
    TextView,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffOrdersSetCancel(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const handleCancel = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handleCancelOrder = async () => {
        await postData('/api/panel/page/taroff-orders-set-cancel/save-data', {
            id: allProps['taroff-orders-id'],
        });
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    useEffect(() => {
        postData('/api/panel/page/taroff-orders-set-cancel/form-data', {
            id: allProps['taroff-orders-id'],
        }).then((response) => {});
    }, []);
    return (
        <PanelBox>
            <DataForm>
                <Title>لغو سفارش</Title>
                <Grid>
                    <GridColumn width={12}>
                        <TextView>سفارش لغو شود ؟</TextView>
                    </GridColumn>
                </Grid>
                <LeftComponents>
                                    <Button onClick={handleCancel}>انصراف</Button>
                <Button onClick={handleCancelOrder}>لغو سفارش</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
